/**
 * Qué cuenta como «carga viva» según el sistema de la empresa.
 *
 * 🚨 Existe porque la respuesta estaba repartida en 28 sitios que preguntaban
 * `= 'EN_TRANSITO'`, y el día que apareció un cuarto estado —`PLANILLADA`— los
 * 28 se equivocaron a la vez: 207 remesas con manifiesto y conductor asignado
 * desaparecieron de las pantallas.
 *
 * ⛔ `CUMPLIDO` y `FACTURADO` NO van: para el sistema de la empresa ese viaje
 * ya se cerró, y mostrarlo como pendiente es lo que llenaba la lista del
 * conductor con doscientos viajes viejos.
 */
export const ACTIVA_EN_ORIGEN = ['PLANILLADA', 'EN_TRANSITO'] as const


export function estaEnLaCalle(estadoVulcano: string | null | undefined): boolean {
  return (ACTIVA_EN_ORIGEN as readonly string[]).includes(estadoVulcano ?? '')
}
